import React from "react";

const Wine = () => {
  return <div>Wine</div>;
};

export default Wine;
